import React, { useEffect, useState } from "react";
import { outreach } from "./outreachApi";
export default function OutreachProspectPicker({
  name,
  value,
  onChange,
  required
}) {
  const [query, setQuery] = useState(""),
    [rows, setRows] = useState([]),
    [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    const timer = setTimeout(() => {
      outreach("prospects", {
        search: query,
        sort: "name"
      }).then(r => {
        if (active) {
          setRows(r.prospects);
          setError("");
        }
      }).catch(e => {
        if (active) setError(e.message);
      });
    }, 200);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [query]);
  return <div className="outreach-prospect-picker"><input aria-label="Find prospect by name" placeholder="Search prospects by name" value={query} onChange={e => setQuery(e.target.value)} /><select name={name} aria-label="Select prospect" required={required} value={value || ""} onChange={onChange}><option value="">Choose a prospect…</option>{value && !rows.some(p => String(p.id) === String(value)) && <option value={value}>Current selected prospect</option>}{rows.map(p => <option key={p.id} value={p.id}>{p.display_name || p.name}{p.do_not_contact ? " — Do Not Contact" : ""}</option>)}</select>{error && <span role="alert">{error}</span>}</div>;
}
